<div class="row">
    <div class="col-md-3">
        <app-instance-sidebar
            [allowedItem]="allowedItem"
            (allowedItemType)="allowedItemTypeHandler($event)"
            (clickItem)="loadDataClicked($event)"
            #child1
        ></app-instance-sidebar>
    </div>
    <div class="col-md-9">
        <span>
            <app-instance-data
                [allowedItem]="selectedAllowedItemList"
                [breadcrumbData]="breadcrumbData"
                (dataChangeEvent)="dataChangeEventHandler($event)"
                (selectItemClick)="_loadDataClicked($event)"
                (refreshClick)="_refreshDataClicked($event)"
                #child2
            ></app-instance-data>
        </span>
    </div>
</div>
